import React from "react";
import video1 from "../assets/Gallery/Web/video2.mp4";

const HowItWorks: React.FC = () => {
  return (
    <div className="bg-white w-full">
      <section className="max-w-7xl mx-auto px-4 py-12">
        <h1 className="text-4xl md:text-5xl font-extrabold mb-4 text-blue-800 drop-shadow">
          How It Works
        </h1>
        <p className="text-lg md:text-xl text-gray-700 mb-8">
          See RoomRounds in action — watch the walkthrough below.
        </p>
        <div className="flex justify-center">
          <div className="rounded-2xl overflow-hidden bg-black shadow-2xl border border-gray-200" style={{ width: "70%" }} mx-auto>
            <video
              className="w-full aspect-video object-contain bg-black"
              controls
              playsInline
              preload="metadata"
            >
              <source src={video1} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        </div>

      </section>
    </div>
  );
};

export default HowItWorks;
